<template>
  <h1>403 Sin Permisos</h1>
</template>
<script>
export default {};
</script>
